<template>
  <div class="codeBox row cen-between ft14 relative">
    <span class="iconIpt ilbk absolute">
      <img src="../../assets/imgs/code.png" alt="" />
    </span>
    <input
      @blur="scrollInto"
      class="code"
      v-model="codeNumber"
      type="text"
      name=""
      placeholder="请输入验证码"
    />
    <div class="textBox row cen-center">
      <span class="lineD1 ilbk"></span>
      <span
        v-if="!codeTime"
        class="gray-D1 padding25_right"
        @click="getCode"
        :class="{ col_3: codeClass }"
        >获取验证码</span
      >
      <span v-if="codeTime" class="gray-D1 padding25_right"
        >{{ time }}S后重新获取</span
      >
    </div>
    <toast ref="toast"></toast>
  </div>
</template>
<script>
import { codeReg } from "@/utils/regular.js";
import Toast from "@/components/toast/tosatInfo";
import { getVerificationCode } from "@/model/user/userServe";
export default {
  data() {
    return {
      codeNumber: "",
      telPhone: {},
      codeClass: false,
      time: 59,
      codeTime: false,
      timer: null,
    };
  },
  props: {
    verify: {
      // 是否验证失败
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  components: {
    Toast,
  },
  watch: {
    codeNumber(val) {
      val = val.trim();
      let codeFlag;
      codeFlag = codeReg.test(val);
      this.$emit("codeEmit", {
        name: val,
        codeFlag: codeFlag,
      });
    },
    verify(val) {
      this.verify = val;
    },
    telPhone(val) {
      if (val.phoneFlag) {
        this.codeClass = true;
      } else {
        this.codeClass = false;
      }
    },
  },
  mounted() {
    this.bus.$on("telPhoneCode", (msg) => {
      this.telPhone = msg;
    });
  },
  methods: {
    cleanInfo() {
      this.applicantName = "";
    },
    getCode() {
      if (this.telPhone && !this.telPhone.phoneFlag) {
        return;
      }
      this.codeTime = true;
      this.timer = setInterval(() => {
        if (this.time > 0) {
          this.time--;
        } else {
          this.show = true;
          clearInterval(this.timer);
          this.timer = null;
          this.time = 59;
          this.codeTime = false;
        }
      }, 1000);
      getVerificationCode({ loginname: this.telPhone.name })
        .then((data) => {
          console.log("验证码", data);
        })
        .catch((err) => {
          console.log("err", err);
        });
    },
    scrollInto() {
      window.setTimeout(function() {
        const scrollHeight =
          document.documentElement.scrollTop || document.body.scrollTop;
        if (scrollHeight) {
          window.scrollTo(0, Math.max(scrollHeight - 1, 0));
        }
      }, 0);
    },
  },
};
</script>
<style lang="less" scoped>
.codeBox {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid rgba(209, 209, 209, 1);
  border-radius: 5px;
  .col_3 {
    color: #333;
  }
  .code {
    height: 45/20rem;
    width: 6rem;
    padding-left: 2rem;
    font-size: 0.7rem;
    border-radius: 5px;
  }
  .textBox {
    height: 45/20rem;
    // line-height:45/20rem;
  }
  .padding25_right {
    padding: 0 25/20rem;
  }
  .lineD1 {
    width: 1px;
    height: 24/20rem;
    background: #d1d1d1;
  }
}
</style>
